import {
  type DashboardActions,
  InternalMembersActions,
} from '@store/reducers/dashboard/actions'
import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'

export function* unsuspend({
  payload,
}: ReturnType<typeof DashboardActions.members.unsuspend>) {
  const { workspaceId, id } = payload
  yield put(InternalMembersActions.update({ ...payload, activity: 'active' }))
  try {
    yield call(NestClient.membership.unsuspend, workspaceId, id)
    yield call(sendGtmEvent, GtmTriggerName.TEAM_MEMBER_UNSUSPEND)
  } catch (e) {
    console.error('Error while unsuspending member', e)
    yield put(GeneralErrorNotification)
  }
  yield put(InternalMembersActions.fetchList({ workspaceId }))
}
